if (!customElements.get('hxz-buy-btn')) {
  customElements.define(
    'hxz-buy-btn',
    class HXZBuyBtn extends HTMLElement {
      constructor() {
        super()
        this.productId = this.dataset.productId
        this.isCustomize = this.dataset.customize === '1'
        this.parentAvailable = this.dataset.parentAvailable !== 'false'
        this.customizeAvailable =
          this.dataset.customizeAvailable !== 'false'
        this.onCustomizeAvailabilityChange =
          this.onCustomizeAvailabilityChange.bind(this)
        this.querySelectorAll('button:not(#sharebtn)').forEach(item => {
          item.addEventListener('click', () => {
            this.submit()
          })
        })
        this.setBtnStatus = this.setBtnStatus.bind(this)

        if (this.querySelector('.hxz-top-buy-wrapper')) {
          window.addEventListener('scroll', () => {
            if (window.scrollY > 250) {
              this.querySelector('.hxz-top-buy-wrapper').style.top =
                'var(--header-height)'
              this.querySelector('.hxz-top-buy-wrapper').classList.remove(
                '-hidden'
              )
            } else {
              this.querySelector('.hxz-top-buy-wrapper').classList.add(
                '-hidden'
              )
            }
          })
        }

        this.querySelectorAll('.addwishlist').forEach(item => {
          item.addEventListener('click', () => {
            if (!window.USERID) {
              location.href = `/account/login?return_url=${location.pathname}`
              return
            }
            let isLike = this.querySelector('.addwishlist')
            if (isLike.dataset.clickId) {
              this.unLikeProduct(isLike.dataset.clickId)
            } else {
              this.likeProduct({
                bizId: this.productId,
                clickBiz: 'product',
                clickType: 'collect',
                userId: window.USERID,
              })
            }
          })
        })

        this.querySelectorAll('.hxz-quantity-add').forEach(item => {
          item.addEventListener('click', () => {
            this.quantityChange(1)
          })
        })

        this.querySelectorAll('.hxz-quantity-minus').forEach(item => {
          item.addEventListener('click', () => {
            this.quantityChange(-1)
          })
        })
      }

      submit() {
        let variantId = this.dataset.variantId
        if (document.querySelector('hxz-variant-radios')) {
          let variant = document
            .querySelector('hxz-variant-radios')
            .getCurrentVariant()
          if (variant) {
            variantId = variant.id
          }
        }

        if (this.isCustomize) {
          const customize = document.querySelector('hxz-sets-customize')
          const customizeData = customize && customize.getSelectedDatas()
          if (!customizeData || !customizeData.valid) {
            this.setCustomizeStatus(false)
            return
          }
          window.addToCart([
            {
              quantity: +this.querySelector('.hxz-quantity-nu').innerText,
              id: variantId,
              properties: {
                _isSet: true,
                _setItems: customizeData.items,
                _customizeSetItems: customizeData.nameDispaly.slice(0, -1),
              },
            },
          ])
          return
        }

        /*
      if (variant) {
        variantId = variant.id
      }
      */
        window.addToCart([
          {
            quantity: +this.querySelector('.hxz-quantity-nu').innerText,
            id: variantId,
          },
        ])
      }

      quantityChange(nu) {
        let quantity = this.querySelector('.hxz-quantity-nu').innerText
        if (+quantity === 1 && nu === -1) return

        let newQuantity = +quantity + nu
        this.querySelectorAll('.hxz-quantity-nu').forEach(item => {
          item.innerText = newQuantity
        })
        // 用于bundle area 组件配合
        this.dispatchEvent(
          new CustomEvent('bundle:change', {
            bubbles: true,
          })
        )
      }

      likeProduct(data) {
        fetch(`/a/choogo/lts/api/v1/click/add`, {
          method: 'POST',
          headers: { 'content-type': 'application/json', station: 'test' },
          body: JSON.stringify(data),
        })
          .then(res => res.json())
          .then(res => {
            if (res.code !== 200) return
            this.querySelector('.addwishlist').dataset.clickId = res.data
            this.querySelectorAll('.addwishlist .heart-symbol').forEach(
              item => {
                item.classList.toggle('hidden')
              }
            )
          })
      }

      setBtnStatus(status) {
        this.parentAvailable = status
        this.renderBtnStatus()
      }

      setCustomizeStatus(status) {
        this.customizeAvailable = status
        this.renderBtnStatus()
      }

      onCustomizeAvailabilityChange(event) {
        this.setCustomizeStatus(event.detail.available)
      }

      renderBtnStatus() {
        const status =
          this.parentAvailable &&
          (!this.isCustomize || this.customizeAvailable)
        if (status) {
          this.querySelectorAll('button:not(#sharebtn)').forEach(item => {
            item.disabled = false
            item.classList.remove('disabled')
            item.querySelector('.sold-out-cover')?.classList.add('-hidden')
          })
        } else {
          this.querySelectorAll('button:not(#sharebtn)').forEach(item => {
            item.disabled = true
            item.classList.add('disabled')
            item.querySelector('.sold-out-cover')?.classList.remove('-hidden')
          })
        }
      }

      unLikeProduct(clickId) {
        fetch(`/a/choogo/lts/api/v1/click/delete/${clickId}`, {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
        })
          .then(res => res.json())
          .then(res => {
            if (res.code !== 200) return
            this.querySelector('.addwishlist').dataset.clickId = ''
            this.querySelectorAll('.addwishlist .heart-symbol').forEach(
              item => {
                item.classList.toggle('hidden')
              }
            )
          })
      }

      getWishlist() {
        fetch(
          `/a/choogo/lts/api/v1/click/list/page?clickType=collect&clickBiz=product&bizId=${this.productId}&userId=${window.USERID}`,
          {
            method: 'GET',
            headers: { 'content-type': 'application/json' },
          }
        )
          .then(res => res.json())
          .then(res => {
            if (res.code !== 200) return
            if (res.data.records.length > 0) {
              const likedClick = res.data.records[0].clickId
              this.querySelector('.addwishlist').dataset.clickId = likedClick
              this.querySelectorAll('.heart-symbol').forEach(item => {
                item.classList.toggle('hidden')
              })
            }
          })
      }

      connectedCallback() {
        if (this.isCustomize) {
          this.customizeComponent = document.querySelector(
            'hxz-sets-customize'
          )
          if (this.customizeComponent) {
            this.customizeComponent.addEventListener(
              'customize:availability-change',
              this.onCustomizeAvailabilityChange
            )
            this.setCustomizeStatus(
              this.customizeComponent.getSelectedDatas().valid
            )
          } else {
            this.setCustomizeStatus(false)
          }
        } else {
          this.renderBtnStatus()
        }

        if (window.USERID) {
          this.getWishlist()
        }
      }

      disconnectedCallback() {
        if (this.customizeComponent) {
          this.customizeComponent.removeEventListener(
            'customize:availability-change',
            this.onCustomizeAvailabilityChange
          )
        }
      }
    }
  )
}
